import { useCallback } from 'react';
import { PaymentService } from '../services/payment.service';
import { ConfigServer } from '../configs/config.server';
import { OrderingForSaleProps } from '../components/main/detailsOrder.props';
import { OrderingParametersForCreate } from '../interfaces/ordering/orderingParametersForCreate';
import { CustomerPaymentState } from '../types/types';
import { Ordering } from '../interfaces/ordering/pre/ordering';

export const useCreateOrdering = (props: OrderingForSaleProps, config: ReturnType<typeof ConfigServer>) => {
  return useCallback(
    async (model: CustomerPaymentState): Promise<string | null> => {
      // Если заказ уже существует, не создаём новый
      if (props.orderingForSale.orderingId) return null;

      const ordering = { ...props.ordering };

      // Заполняем данные покупателя в пропсе ordering (если он есть)
      if (ordering) {
        ordering.customer = {
          email: model.email,
          firstName: model.firstName,
          lastName: model.lastName,
          phone: +model.phone.replace(/[^0-9]/g, ''),
          pin: null,
          bitrixId: null,
          contactId: null,
        };

        if (ordering.campaignNumber === '') {
          ordering.campaignNumber = null;
        }
      }

      const orderingParametersForCreate: OrderingParametersForCreate = {
        googleAnalytics: null,
        preOrderingId: props.preOrderingId,
        ordering: ordering as Ordering,
      };

      const result = await PaymentService.createOrderingV2(
        orderingParametersForCreate,
        config.ServiceOrdering.CreateOrderingV2
      );

      return result.isError ? null : result.orderingId;
    },
    [props.ordering, props.orderingForSale.orderingId, props.preOrderingId, config]
  );
};